module.exports = __webpack_public_path__ + "static/img/7.1234c40.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/8/zh/7.png
// module id = CrrD
// module chunks = 0